(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    // this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lac-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lac-hero')) {
    customElements.define('lac-hero', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-index]'));this.index=0;
        this.preloadNext();
        this.querySelector('[data-prev]')?.addEventListener('click',()=>this.show(this.index-1),options);
        this.querySelector('[data-next]')?.addEventListener('click',()=>this.show(this.index+1),options);
        this.dots.forEach(dot=>dot.addEventListener('click',()=>this.show(Number(dot.dataset.index)),options));
        this.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1));}},options);
        this.addEventListener('touchstart',event=>{this.touchX=event.changedTouches[0].clientX;this.touchY=event.changedTouches[0].clientY;},{...options,passive:true});
        this.addEventListener('touchend',event=>{const dx=event.changedTouches[0].clientX-this.touchX;const dy=event.changedTouches[0].clientY-this.touchY;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx<0?1:-1));},{...options,passive:true});
        document.addEventListener('shopify:block:select',event=>{const index=this.slides.findIndex(slide=>slide===event.target||slide.contains(event.target));if(index>=0)this.show(index);},options);
      }
      preloadNext() {
        if(this.slides.length<2)return;
        const index=this.index;
        const image=this.slides[index].querySelector('img');
        const signal=this.abort.signal;
        const preload=()=>requestAnimationFrame(()=>requestAnimationFrame(()=>{
          if(signal.aborted||this.index!==index)return;
          const next=this.slides[(index+1)%this.slides.length].querySelector('img');
          if(next&&next.loading==='lazy'){
            next.fetchPriority='low';
            next.loading='eager';
          }
        }));
        if(!image||image.complete)preload();
        else {
          image.addEventListener('load',preload,{once:true,signal});
          image.addEventListener('error',preload,{once:true,signal});
        }
      }
      show(index) {if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>slide.hidden=i!==this.index);this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));const image=this.slides[this.index].querySelector('img');if(image){image.fetchPriority='high';image.loading='eager';}this.preloadNext();}
      disconnectedCallback(){this.abort?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lac-installation-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lac-installation-videos')) {
  customElements.define('lac-installation-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const rail = this.querySelector('.lac-installation-videos__grid');
      this.querySelectorAll('[data-scroll]').forEach(button => button.addEventListener('click', () => {
        const card = rail.querySelector('article');
        if (!card) return;
        rail.scrollBy({left: Number(button.dataset.scroll) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, options));
      const previews = [...this.querySelectorAll('.lac-installation-videos__play video')];
      const dialog = this.querySelector('dialog');
      const player = dialog.querySelector('video');
      const toggle = this.querySelector('[data-preview-toggle]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reducedMotion.matches || this.dataset.autoplay !== 'true';
      let trigger;
      let oldOverflow;
      const updateToggle = () => {
        if (!toggle) return;
        toggle.textContent = paused ? toggle.dataset.resume : toggle.dataset.pause;
        toggle.setAttribute('aria-pressed', String(paused));
      };
      const sync = () => previews.forEach(video => {
        if (video.dataset.visible === 'true' && !paused && !dialog.open && !document.hidden) {
          video.muted = true;
          video.play().catch(() => {});
        } else video.pause();
      });
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const video = entry.target;
          video.dataset.visible = String(entry.isIntersecting);
          if (entry.isIntersecting && !video.getAttribute('src')) {
            video.src = video.dataset.src;
            video.preload = 'metadata';
            video.load();
          }
        });
        sync();
      }, { threshold: 0.2 });
      previews.forEach(video => this.observer.observe(video));
      document.addEventListener('visibilitychange', sync, options);
      toggle?.addEventListener('click', () => { paused = !paused; updateToggle(); sync(); }, options);
      this.querySelectorAll('[data-video]').forEach(button => button.addEventListener('click', () => {
        trigger = button;
        oldOverflow = document.body.style.overflow;
        player.src = button.dataset.video;
        player.muted = false;
        dialog.setAttribute('aria-label', button.getAttribute('aria-label'));
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        sync();
        player.play().catch(() => {});
      }, options));
      const cleanup = () => {
        player.pause();
        player.removeAttribute('src');
        player.load();
        document.body.style.overflow = oldOverflow || '';
      };
      dialog.querySelector('button').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => { cleanup(); trigger?.focus(); sync(); }, options);
      this.cleanup = () => { if (dialog.open) { dialog.close(); cleanup(); } };
      updateToggle();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.cleanup?.();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lac-popular"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lac-popular')) {
  customElements.define('lac-popular', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault(); this.select(next); this.tabs[next].focus();
        });
      });
      this.initializePanel = panel => {
        if (panel.update) return;
        const deferred = panel.querySelector("template");
        if (deferred) deferred.replaceWith(deferred.content.cloneNode(true));
        const track = panel.querySelector('.lac-popular__track');
        const cards = [...track.children];
        if (this.dataset.sortByRating !== 'false') cards.sort((a, b) => Number(b.dataset.rating) - Number(a.dataset.rating) || Number(b.dataset.reviewCount) - Number(a.dataset.reviewCount));
        track.append(...cards);
        track.scrollTo({left: 0, behavior: 'instant'});
        const prev = panel.querySelector('.lac-popular__prev');
        const next = panel.querySelector('.lac-popular__next');
        const update = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
        const move = direction => track.scrollBy({left: direction * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, {passive:true});
        panel.update = update;
        update();
      };
      this.initializePanel(this.panels[0]);
      this.observer = new ResizeObserver(() => this.panels.forEach(panel => {if (!panel.hidden) panel.update();}));
      this.observer.observe(this);
      this.addEventListener('shopify:block:select', event => {const index = this.panels.indexOf(event.target.closest('[role="tabpanel"]')); if(index >= 0) this.select(index);});
    }
    select(index) {
      this.tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; this.panels[i].hidden = i !== index;});
      this.initializePanel(this.panels[index]);
      this.panels[index].update();
    }
    disconnectedCallback() {this.observer?.disconnect(); this.ready = false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lac-ppf-install-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lac-installation-videos')) {
  customElements.define('lac-installation-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const rail = this.querySelector('.lac-installation-videos__grid');
      this.querySelectorAll('[data-scroll]').forEach(button => button.addEventListener('click', () => {
        const card = rail.querySelector('article');
        if (!card) return;
        rail.scrollBy({left: Number(button.dataset.scroll) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, options));
      const previews = [...this.querySelectorAll('.lac-installation-videos__play video')];
      const dialog = this.querySelector('dialog');
      const player = dialog.querySelector('video');
      const toggle = this.querySelector('[data-preview-toggle]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reducedMotion.matches || this.dataset.autoplay !== 'true';
      let trigger;
      let oldOverflow;
      const updateToggle = () => {
        if (!toggle) return;
        toggle.textContent = paused ? toggle.dataset.resume : toggle.dataset.pause;
        toggle.setAttribute('aria-pressed', String(paused));
      };
      const sync = () => previews.forEach(video => {
        if (video.dataset.visible === 'true' && !paused && !dialog.open && !document.hidden) {
          video.muted = true;
          video.play().catch(() => {});
        } else video.pause();
      });
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const video = entry.target;
          video.dataset.visible = String(entry.isIntersecting);
          if (entry.isIntersecting && !video.getAttribute('src')) {
            video.src = video.dataset.src;
            video.preload = 'metadata';
            video.load();
          }
        });
        sync();
      }, { threshold: 0.2 });
      previews.forEach(video => this.observer.observe(video));
      document.addEventListener('visibilitychange', sync, options);
      toggle?.addEventListener('click', () => { paused = !paused; updateToggle(); sync(); }, options);
      this.querySelectorAll('[data-video]').forEach(button => button.addEventListener('click', () => {
        trigger = button;
        oldOverflow = document.body.style.overflow;
        player.src = button.dataset.video;
        player.muted = false;
        dialog.setAttribute('aria-label', button.getAttribute('aria-label'));
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        sync();
        player.play().catch(() => {});
      }, options));
      const cleanup = () => {
        player.pause();
        player.removeAttribute('src');
        player.load();
        document.body.style.overflow = oldOverflow || '';
      };
      dialog.querySelector('button').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => { cleanup(); trigger?.focus(); sync(); }, options);
      this.cleanup = () => { if (dialog.open) { dialog.close(); cleanup(); } };
      updateToggle();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.cleanup?.();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lac-tail-finish-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lac-tail-finishes')) customElements.define('lac-tail-finishes',class extends HTMLElement {
 connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[role="tab"]')],panels=[...this.querySelectorAll('[role="tabpanel"]')];const select=n=>tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===n));t.tabIndex=i===n?0:-1;panels[i].hidden=i!==n;});tabs.forEach((t,i)=>{t.addEventListener('click',()=>select(i));t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();select(n);tabs[n].focus();});});this.addEventListener('shopify:block:select',e=>{const n=panels.indexOf(e.target.closest('[role="tabpanel"]'));if(n>=0)select(n);});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lac-tail-model-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lac-tail-products')) {
  customElements.define('lac-tail-products', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('.lac-popular__panel')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault(); this.select(next); this.tabs[next].focus();
        });
      });
      this.initializePanel = panel => {
        if (panel.update) return;
        const deferred = panel.querySelector("template");
        if (deferred) deferred.replaceWith(deferred.content.cloneNode(true));
        const track = panel.querySelector('.lac-popular__track');
        const cards = [...track.children];
        if (this.dataset.sortByRating !== 'false') cards.sort((a, b) => Number(b.dataset.rating) - Number(a.dataset.rating) || Number(b.dataset.reviewCount) - Number(a.dataset.reviewCount));
        track.append(...cards);
        track.scrollTo({left: 0, behavior: 'instant'});
        const prev = panel.querySelector('.lac-popular__prev');
        const next = panel.querySelector('.lac-popular__next');
        const update = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
        const move = direction => track.scrollBy({left: direction * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, {passive:true});
        panel.update = update;
        update();
      };
      if (!this.panels.length) return;
      this.initializePanel(this.panels[0]);
      this.observer = new ResizeObserver(() => this.panels.forEach(panel => {if (!panel.hidden) panel.update();}));
      this.observer.observe(this);
      this.addEventListener('shopify:block:select', event => {const index = this.panels.indexOf(event.target.closest('.lac-popular__panel')); if(index >= 0) this.select(index);});
    }
    select(index) {
      this.tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; this.panels[i].hidden = i !== index;});
      this.initializePanel(this.panels[index]);
      this.panels[index].update();
    }
    disconnectedCallback() {this.observer?.disconnect(); this.ready = false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lac-testimonials"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lac-testimonials'))customElements.define('lac-testimonials',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const track=this.querySelector('.lac-testimonials-track'),cards=[...track.children],arrows=[...this.querySelectorAll('[data-direction]')],dialog=this.querySelector('dialog'),player=dialog.querySelector('video'),previews=[...this.querySelectorAll('.lac-testimonials-preview')];
const index=()=>Math.round(track.scrollLeft/(cards[0].offsetWidth+24));
let active=-1;
const startAt=v=>Math.min(Number(v.dataset.start)||5,Math.max(0,(Number.isFinite(v.duration)?v.duration:6)-.1));
const sync=()=>previews.forEach((v,i)=>{
const showing=this.visible&&i===index()&&!dialog.open&&!document.hidden;
if(!showing){v.pause();return;}
if(!v.src){v.preload='auto';v.src=v.dataset.src;v.load();return;}
if(v.readyState<1||v.seeking)return;
if(!v.dataset.positioned){v.currentTime=startAt(v);return;}
v.muted=true;v.play().catch(()=>{});
});
previews.forEach(v=>{
v.addEventListener('loadedmetadata',()=>{v.currentTime=startAt(v);});
v.addEventListener('seeked',()=>{if(v.currentTime>=startAt(v)-.05){v.dataset.positioned='true';v.classList.add('is-ready');sync();}});
v.addEventListener('ended',()=>{delete v.dataset.positioned;v.classList.remove('is-ready');v.currentTime=startAt(v);});
});
const update=()=>{const next=index();if(next!==active){active=next;const v=previews[next];v.pause();delete v.dataset.positioned;v.classList.remove("is-ready");if(v.readyState>=1)v.currentTime=startAt(v);}arrows[0].disabled=index()<=0;arrows[1].disabled=index()>=cards.length-1;sync();};
arrows.forEach(button=>button.addEventListener('click',()=>{const next=Math.max(0,Math.min(cards.length-1,index()+Number(button.dataset.direction)));track.scrollTo({left:next*(cards[0].offsetWidth+24),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));
track.addEventListener('scroll',update,{passive:true});
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;sync();},{threshold:.2});this.observer.observe(track);
this.onVisibility=sync;document.addEventListener('visibilitychange',sync);update();
this.querySelectorAll('.lac-testimonials-play').forEach(button=>button.addEventListener('click',()=>{this.trigger=button;previews.forEach(v=>v.pause());player.src=button.dataset.video;player.muted=false;player.currentTime=0;this.oldOverflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';player.play().catch(()=>{});}));
dialog.querySelector('button').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
dialog.addEventListener('close',()=>{player.pause();player.removeAttribute('src');player.load();document.body.style.overflow=this.oldOverflow||'';this.trigger?.focus();sync();});
}
disconnectedCallback(){this.observer?.disconnect();document.removeEventListener('visibilitychange',this.onVisibility);this.querySelectorAll('video').forEach(v=>v.pause());}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
function initLacArticle(root) {
  root.querySelectorAll('[data-lac-article]').forEach(article => {
    const toc = article.querySelector('.lac-article__toc');
    if (!toc || toc.dataset.ready) return;
    const headings = [...article.querySelectorAll('.lac-article__content h2, .lac-article__content h3')].filter(heading => heading.textContent.trim());
    if (headings.length < 3) return;
    const list = toc.querySelector('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = 'lac-article-heading-' + index;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
    toc.hidden = false;
    toc.dataset.ready = 'true';
  });
}
initLacArticle(document);
document.addEventListener('shopify:section:load', event => initLacArticle(event.target));

  } catch(e) { console.error(e); }
})();
})();
